export default function initCategoriesHome() {
    const sliderElement = document.querySelector('.c-categories__slider');
    const containerElement = document.querySelector('.c-categories'); // Usado para buscar as setas em segurança

    if (!sliderElement || !containerElement) return;

    const prevButton = containerElement.querySelector('.c-categories__nav--prev');
    const nextButton = containerElement.querySelector('.c-categories__nav--next');

    const catSwiper = new Swiper(sliderElement, {
        slidesPerView: 1.25,
        spaceBetween: 20,
        breakpointsBase: 'container',
        loop: true,

        effect: 'creative',
        creativeEffect: {
            limitProgress: 8,
            prev: {
                translate: [0, 0, -400],
                opacity: 0,
            },
            next: {
                translate: ['calc(100% + 20px)', 0, 0],
            },
        },

        navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
        },

        breakpoints: {
            // Usa o espaço real do carrossel e mantém parte do próximo card visível.
            480: {
                slidesPerView: 2.25,
            },
            820: {
                slidesPerView: 3.25,
            }
        },

        a11y: {
            prevSlideMessage: 'Categorias anteriores',
            nextSlideMessage: 'Próximas categorias',
        }
    });
}
